// В.2.d-1: Реаниматор (liv_reanimator, rare, 2/1/5).
// Триггер: «[Когда умирает союзный юнит]: лечит Героя на 2 ХП».
//
// Реализация:
//   - Подписываемся на onUnitDiedExtras (тот же механизм что у Донора в В.2.b).
//   - В обработчике: для каждого живого Реаниматора на поле (с тем же
//     ownerIdx, что и умерший юнит) — если умерший ≠ сам этот Реаниматор и
//     умерший не вражеский → healUnit(Hero, 2, source=Реаниматор).
//   - Молчание Реаниматора блокирует триггер.
//   - Если Реаниматоров несколько — каждый срабатывает отдельно.
//   - Если умирает САМ Реаниматор — он не триггерит на свою смерть
//     (он уже не на поле к моменту обработки extras-handler'а).
//   - Если умер вражеский юнит — фильтр по ownerIdx отбрасывает.
//   - Если Герой на полном ХП — healUnit вернёт actualAmount=0, событие
//     healed не эмитится. Это норма.

import { registerImplementedAbility } from './warn-unimplemented.js';
import { registerOnUnitDiedExtraHandler } from '../deus/hooks.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_reanimator';
const LABEL = 'Реаниматор';
const HEAL_AMOUNT = 2;

registerImplementedAbility(CARD_ID, 'trigger');

registerOnUnitDiedExtraHandler((state, payload) => {
  const dead = payload?.card;
  if (!dead) return;
  if (dead.type !== 'unit') return;
  // Сторона умершего.
  const deadOwnerIdx = payload.ownerIdx;
  if (deadOwnerIdx == null) return;
  const owner = state.players?.[deadOwnerIdx];
  if (!owner) return;
  // Найти всех живых Реаниматоров на той же стороне.
  const reanimators = owner.unitsOnField().filter(u =>
    u.id === CARD_ID && u.isAlive() && u !== dead
  );
  if (reanimators.length === 0) return;
  for (const r of reanimators) {
    // Молчание Реаниматора блокирует.
    if (r.current?.silenced) continue;
    if (r.silenceSources && r.silenceSources.size > 0) continue;
    state.log?.add(
      `🩹 ${LABEL} [${owner.name}]: +${HEAL_AMOUNT} ХП Герою (умер ${dead.name_ru || dead.id})`
    );
    healUnit(state, owner.hero, HEAL_AMOUNT, r);
  }
});
